export default "__VITE_ASSET__Qgr3nvMA__"